<template>
  <div class="container">
    <div>
      <p class="treasury-text">Treasury Value</p>
      <div class="value-container">
        <p class="value">$15,023</p>
        <div class="icon-container"><img class="arrow-icon" src="@/assets/community/value-up.svg" alt="">
          <p class="positive-text">+23%</p></div>
      </div>
      <p class="total-vibes">15,646,919 VIBES</p>
    </div>
    <div>
      <p class="tre-text">Treasury Address:</p>
      <div class="address-container">
        <p class="address">SP82P1X2P478K4K30F7NCE8WMQ40SZSKFXBPWVBJ</p>
        <p class="explorer-text">View In Explorer</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreasuryCard',
  data () {
    return {

    }
  }
}
</script>

<style scoped>

.container{
  border-radius: 5px;
  border: 1px solid #D9D9D9;
  background: #FFF;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 260px;
}

.treasury-text{
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.value-container{
  display: flex;
  margin-top: 16px;
  gap:24px
}

.value{
  color: #000;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.icon-container{
  display: flex;
  gap: 5px;
  align-items: center;
}

.arrow-icon{
  width: 21px;
  height: 21px;
}
.positive-text{
  color: #39E592;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.total-vibes{
  margin-top: 10px;
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.tre-text{
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.address-container{
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
}

@media (max-width: 760px) {
  .address-container{
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
  }
}

.address{
  flex-grow: 1;
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.explorer-text{
  cursor: pointer;
  color: #31E5FF;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/dao-community/treasury-card.vue